import * as React from 'react';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import removePhraseFromClause from '../actions/helpers/removePhraseFromClause';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import isValidClause from '../utils/isValidClause';
import setClauseErrorText from '../actions/helpers/setClauseErrorText';

const styles = require('./PhrasePill.scss');

export interface PhrasePillProps {
    phrase: string;
    clauseId: string;
}

/*
Phrase pills are used in the 'includes these words' clauses for inbox rules.
A user enters text in the input and presses enter to commit the phrase and
create a phrase pill
*/
@observer
export default class PhrasePill extends React.Component<PhrasePillProps, {}> {
    render() {
        return (
            <div className={styles.phrasePill}>
                <span className={styles.phrasePillText} title={this.props.phrase}>
                    {this.props.phrase}
                </span>
                <IconButton
                    className={styles.phrasePillClose}
                    iconProps={{
                        iconName: ControlIcons.Cancel,
                        styles: {
                            root: styles.cancelIcon,
                        },
                    }}
                    onClick={() => {
                        removePhraseFromClause(this.props.clauseId, this.props.phrase);
                        setClauseErrorText(this.props.clauseId, isValidClause(this.props.clauseId));
                    }}
                />
            </div>
        );
    }
}
